var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-dialog",
    {
      attrs: { "md-active": _vm.show },
      on: {
        "update:mdActive": function ($event) {
          _vm.show = $event
        },
        "update:md-active": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c("md-dialog-title", [_vm._v(_vm._s(_vm.t("app-save-filter")))]),
      _vm._v(" "),
      _c("md-dialog-content", { staticClass: "standard-form-style" }, [
        _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-input", {
              attrs: {
                type: "text",
                label: _vm.t("app-title"),
                required: "true",
              },
              model: {
                value: _vm.filter.attributes.title,
                callback: function ($$v) {
                  _vm.$set(_vm.filter.attributes, "title", $$v)
                },
                expression: "filter.attributes.title",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-cancel")))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function ($event) {
                  _vm.show = false
                  _vm.$emit("save")
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }